import Layout from './Layout'

import enhance from './Layout.enhancer'

export default enhance(Layout)



// WEBPACK FOOTER //
// ./src/App/components/Layout/index.js